import { Grid, TextField } from "@mui/material";
export default function CreateAttributeForm(props: any) {
  const { formik } = props;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          sx={{ mt: "2%" }}
          name="attributeName"
          label="Attribute Name"
          placeholder="Enter Attribute Name"
          value={formik.values.attributeName}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.attributeName)}
          helperText={
            formik.errors.attributeName ||
            `${formik.values.attributeName.trim().length}/100`
          }
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          minRows={5}
          name="attributeDescription"
          label="Description"
          placeholder="Enter Description"
          value={formik.values.attributeDescription}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.attributeDescription)}
          helperText={
            formik.errors.attributeDescription ||
            `${formik.values.attributeDescription.trim().length}/500`
          }
        />
      </Grid>
    </Grid>
  );
}
